/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Modal, Space, Tag, Tooltip, Typography } from 'antd';

import { CarOutlined, EditOutlined, UserOutlined } from '@ant-design/icons';

import DriverVehicleSelector from '../../ScheduleConecta/Components/FormFields/DriverVehicleSelector';

const { Text } = Typography;

function DriverVehicleCellEditor({
  value = [],
  onChange,
  driverOptions = [],
  vehicleOptions = [],
  transportCompany,
  fieldsPermissions = {},
  disabled = false,
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [internalValue, setInternalValue] = useState(value || []);
  const [driverListOptions, setDriverListOptions] = useState([]);
  const [vehicleListOptions, setVehicleListOptions] = useState([]);

  useEffect(() => {
    setInternalValue(value || []);
  }, [value]);

  const updateFilteredOptions = () => {
    if (!transportCompany?.driverList || !transportCompany?.vehicleList) {
      setDriverListOptions([]);
      setVehicleListOptions([]);
      return;
    }

    if (Array.isArray(transportCompany.driverList)) {
      const driverOptionsIds = driverOptions.map(({ userId }) => userId);
      const filteredDrivers = transportCompany.driverList
        .filter(({ id }) => driverOptionsIds.includes(id))
        .map((item) => {
          const driverObj = driverOptions.find(({ userId }) => userId === item.id);
          return driverObj
            ? { ...driverObj, label: driverObj.userName, value: driverObj.userId }
            : null;
        })
        .filter(Boolean);

      setDriverListOptions(filteredDrivers);
    }

    if (Array.isArray(transportCompany.vehicleList)) {
      const filteredVehicles = transportCompany.vehicleList.map((item) => ({
        ...item,
        label: `${item.licensePlate} - ${item.type.name} - ${item.capacity} pessoas`,
        value: item.id,
      }));
      setVehicleListOptions(filteredVehicles);
    }
  };

  useEffect(() => {
    updateFilteredOptions();
  }, [transportCompany, driverOptions, vehicleOptions]);

  const handleSave = () => {
    if (onChange) {
      onChange(internalValue);
    }
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setInternalValue(value || []);
    setIsModalVisible(false);
  };

  const renderDisplayValue = () => {
    if (!internalValue?.length) {
      return <Text type="secondary">Nenhum motorista selecionado</Text>;
    }

    return (
      <Space direction="vertical" size={4} style={{ width: '100%' }}>
        {internalValue.map((driver, index) => (
          <div
            key={driver.userId || index}
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            <Tag icon={<UserOutlined />} color="blue">
              {driver.userName}
            </Tag>
            {driver.vehicle && (
              <Tag icon={<CarOutlined />} color="green">
                {driver.vehicle.licensePlate}
              </Tag>
            )}
          </div>
        ))}
      </Space>
    );
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
        <div style={{ flex: 1, minHeight: 32 }}>{renderDisplayValue()}</div>
        <Tooltip
          title={
            disabled || !transportCompany?.id ? 'Selecione uma empresa de transporte' : 'Editar'
          }
        >
          <EditOutlined
            style={{
              marginLeft: 5,
              color: disabled || !transportCompany?.id ? '#999999' : '#000000d9',
              cursor: disabled || !transportCompany?.id ? 'not-allowed' : 'pointer',
            }}
            onClick={disabled || !transportCompany?.id ? undefined : () => setIsModalVisible(true)}
          />
        </Tooltip>
      </div>

      <Modal
        title="Editar Motoristas e Veículos"
        open={isModalVisible}
        onOk={handleSave}
        onCancel={handleCancel}
        width={800}
        okText="Aplicar"
        cancelText="Cancelar"
        destroyOnClose
        className="training-list-driver-vehicle-modal"
        okButtonProps={{
          style: { backgroundColor: '#5cb85c', color: 'white', border: 'none' },
        }}
        cancelButtonProps={{
          style: { backgroundColor: '#fff', color: '#333', border: 'none' },
        }}
      >
        <DriverVehicleSelector
          value={internalValue}
          onChange={setInternalValue}
          driverListOptions={driverListOptions}
          vehicleListOptions={vehicleListOptions}
          stages={[]}
          fieldsPermissions={fieldsPermissions}
          isTaskReadOnly={false}
          isEditing={true}
        />
      </Modal>
    </>
  );
}

export default DriverVehicleCellEditor;
